const invoicesTypes = {
    GET_ALL_INVOICES: "GET_ALL_INVOICES"
};

export default invoicesTypes;